export class ProtobufError extends Error {
  constructor(message?: string) {
    super(message)
    this.name = "ProtobufError"
  }
}
